export default "<p>emptyinputform works!</p>\r\n<mat-slider min=\"1\" max=\"100\" step=\"1\" value=\"50\"></mat-slider>\r\n"